import React, { useContext, useState, Component } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";

import Schedule from "./Schedule";
import Request from "./Request";
import Complete from "./Complete";
import { Task, Settings } from "../../../helpers/Contexts";
import Cancel from "./Cancel";
import CprData from "../cpr/CprData";
import * as CONST from "../../../helpers/Constants";
import DataEntryNeeded from "../DataEntryNeeded";

const Appointment = ({ task, children, dispatch }) => {
  const { taskValues, setTaskValues } = useContext(Task);

  const disableEdit = {
    request:
      task.appointment_request_status == "appointment_confirmed" ||
      task.appointment_request_status == "visit_status_check" ||
      task.appointment_request_status == "appointment_completed" ||
      task.appointment_request_status == "appointment_not_completed" ||
      taskValues.editing.scheduled ||
      taskValues.editing.completed
        ? true
        : false,
    scheduled:
      taskValues.editing.requested ||
      taskValues.editing.completed ||
      task.appointment_request_status == "visit_status_check" ||
      task.appointment_request_status == "appointment_not_completed" ||
      task.appointment_request_status == "appointment_completed"
        ? true
        : false,
    completed:
      task.appointment_request_status == "appointment_confirmed" ||
      task.status == "closed" ||
      task.appointment_request_status == "appointment_not_completed"
        ? true
        : false,
  };

  return (
    <>
      <Row className="flex">
        <Col md={3} className="task-actions br bxsh">
          {!disableEdit.request && (
            <Button
              id="btn outline"
              className={taskValues.editing.requested && "show-cancel"}
              disabled={disableEdit.request}
              onClick={() => {
                !taskValues.editing.requested
                  ? setTaskValues({
                      ...taskValues,
                      editing: { ...taskValues.editing, requested: true },
                    })
                  : setTaskValues({
                      ...taskValues,
                      editing: { ...taskValues.editing, requested: false },
                    });
              }}
            >
              {taskValues.editing.requested && "Cancel"}
              {!taskValues.editing.requested && "Edit Request"}
            </Button>
          )}
          {!disableEdit.scheduled && (
            <Button
              id="btn outline"
              className={taskValues.editing.scheduled && "show-cancel"}
              disabled={disableEdit.scheduled}
              onClick={() => {
                !taskValues.editing.scheduled
                  ? setTaskValues({
                      ...taskValues,
                      editing: { ...taskValues.editing, scheduled: true },
                    })
                  : setTaskValues({
                      ...taskValues,
                      editing: { ...taskValues.editing, scheduled: false },
                    });
              }}
            >
              {task.appointment_request_status == "appointment_request_created" &&
              !taskValues.editing.scheduled
                ? "Schedule Appointment"
                : taskValues.editing.scheduled
                ? "Cancel"
                : "Edit Scheduled Appointment"}
            </Button>
          )}
          {(task.appointment_request_status == "appointment_completed" ||
            task.appointment_request_status == "appointment_not_completed" ||
            task.cpr.completed_on_date) && (
            <Button
              className={taskValues.editing.completed && "show-cancel"}
              id="btn outline"
              disabled={disableEdit.completed}
              onClick={() => {
                !taskValues.editing.completed
                  ? setTaskValues({
                      ...taskValues,
                      editing: { ...taskValues.editing, completed: true },
                    })
                  : setTaskValues({
                      ...taskValues,
                      editing: { ...taskValues.editing, completed: false },
                    });
              }}
            >
              {taskValues.editing.completed && "Cancel"}
              {!taskValues.editing.completed && "Edit Completed Appointment"}
            </Button>
          )}
          {task.cpr.id && task.appointment_request_status !== "appointment_not_completed" && (
            <CprData
              data={{
                ...task.cpr,
                task: task,
                taskId: task.id,
                formHandler: (req) => task.formHandler(req),
              }}
            />
          )}
        </Col>
        <Col md={9}>
          <Row className="cards-container">
            {task.cpr.sub_status !== null && task.cpr.sub_status == CONST.CPR.RESULTS_OBTAINED && (
              <DataEntryNeeded task={{ ...task }} />
            )}

            {(task.appointment_request_status == "visit_status_check" ||
              task.appointment_request_status == "appointment_not_completed" ||
              task.appointment_request_status == "appointment_completed") && (
              <Complete
                appointment={{
                  ...task,
                }}
                formHandler={task.formHandler}
              />
            )}
            <Schedule
              appointment={task}
              formHandler={task.formHandler}
              children={
                <>
                  {task.appointment_request_status == "appointment_confirmed" && (
                    <Cancel formHandler={task.formHandler} taskId={task.id} />
                  )}
                </>
              }
            />
            <Request appointment={task} formHandler={task.formHandler} />
          </Row>
        </Col>
      </Row>
      <Row className="flex pad20 bt">{children}</Row>
    </>
  );
};

export default Appointment;
